/**
 *
 * @param {TreeRecord} tree
 * @param {Map} nodeTypeById
 */
const moveDocumentsToTopOfParents = (tree, isFolderById) => {
  // First, call it recursively for these children
  const allChildren = tree.children.map(subtree => moveDocumentsToTopOfParents(subtree, isFolderById));

  // Now, sort the items at this level into the correct order
  const childDocs = allChildren.filter(c => !isFolderById.get(c.id));
  const childFolders = allChildren.filter(c => isFolderById.get(c.id));

  return tree.set("children", childDocs.concat(childFolders));
};

export default moveDocumentsToTopOfParents;
